import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendDuoPush } from 'services/pod';
import { ISendPushNotificationPayload } from 'services/pod/types';
import { ISendErrorPayload, extractSendErrorPayload } from './sendErrorPayload';

export const ThunkSendDuoPush = createAsyncThunk<
  unknown,
  ISendPushNotificationPayload,
  { rejectValue: ISendErrorPayload }
>('pod/sendDuoPush', async (payload, { rejectWithValue }) => {
  try {
    const res = await sendDuoPush(payload);
    return res.data;
  } catch (err) {
    return rejectWithValue(extractSendErrorPayload(err));
  }
});
